module.exports = __webpack_public_path__ + "static/img/son2_active.6cad0a8e.png";